import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { del, get, post, patch } from "../../api/api";

// Listar motivos
export const listarMotivos = async () => {
  return await get<IRespostaFuncao<any[]>>(`/motivos-status-empresas/obtem-motivos`);
};

// Criar motivo
export const criarMotivo = async (
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/motivos-status-empresas/cria-motivo`,
    payload
  );
};

// Atualizar motivo
export const atualizarMotivo = async (
  motivoId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/motivos-status-empresas/${motivoId}/atualiza-motivo`,
    payload
  );
};

// Deletar motivo
export const deletarMotivo = async (
  motivoId: string
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/motivos-status-empresas/${motivoId}/remove-motivo`
  );
};
